import {FC} from 'react';

interface Props {
  fill?: string;
  size?: number;
}

export const LogoutIcon: FC<Props> = ({fill = '#000', size = 48}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4998 8.66667L23.8332 13M23.8332 13L19.4998 17.3333M23.8332 13H9.74984M16.2498 4.55438C14.8689 3.7248 13.2655 3.25 11.5554 3.25C6.37005 3.25 2.1665 7.61522 2.1665 13C2.1665 18.3848 6.37005 22.75 11.5554 22.75C13.2655 22.75 14.8689 22.2752 16.2498 21.4456"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogoutIcon;
